import { useCallback } from 'react';
import { toast } from 'sonner';

import { useProjectSiteNavigation } from '@/shared/lib';

export function useConsignmentEdit(consignmentId?: string) {
  const { navigateWithContext } = useProjectSiteNavigation();

  const handleSave = useCallback(
    async (formData: unknown) => {
      if (!consignmentId) {
        toast.error('No consignment ID provided');
        return;
      }

      try {
        // TODO: Implement API call to save consignment
        console.log('Saving consignment:', consignmentId, formData);
        toast.success('Consignment saved successfully');
      } catch (error) {
        toast.error('Failed to save consignment');
        console.error('Failed to save consignment:', error);
      }
    },
    [consignmentId]
  );

  const handleCancel = useCallback(() => {
    navigateWithContext('requests');
  }, [navigateWithContext]);

  return {
    handleSave,
    handleCancel,
    isLoading: false // TODO: Add loading state from API
  };
}
